/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormDateTimeField, {
  FormDateTimeFieldProps
} from '../../../../client/js/components/form/fields/FormDatetimeField'

function NoticeDateField (props: FormDateTimeFieldProps) {
  const { name = 'noticeDate', ...others } = props
  const intl = useIntl()
  return (
    <FormDateTimeField
      label={intl.formatMessage({
        id: 'tenant_notice_date',
        defaultMessage: 'Date de préavis du locataire'
      })}
      name={name}
      {...others}
    />
  )
}

export default NoticeDateField
